/**
 * Rate Limit Badge Component
 * Displays rate limit information for unauthenticated users
 */

import { Badge, Tooltip } from '@mantine/core';
import React from 'react';
import { formatRateLimitTooltip, getRateLimitBadgeColor } from '../../lib/chat-utils';
import type { RateLimitBadgeProps } from '../../types/chat';

export const RateLimitBadge = React.memo<RateLimitBadgeProps>(
  ({ rateLimitInfo, isLoggedIn, isDesktop }) => {
    // Don't show for logged in users or when no rate limit info
    if (isLoggedIn || !rateLimitInfo || rateLimitInfo.limit_requests <= 0) {
      return null;
    }

    const badgeColor = getRateLimitBadgeColor(
      rateLimitInfo.remaining_requests,
      rateLimitInfo.limit_requests
    );

    const tooltipContent = formatRateLimitTooltip(rateLimitInfo);

    // Show abbreviated text on mobile
    const badgeText =
      isDesktop !== false
        ? `${rateLimitInfo.remaining_requests}/${rateLimitInfo.limit_requests} requests`
        : `${rateLimitInfo.remaining_requests}/${rateLimitInfo.limit_requests}`;

    return (
      <Tooltip label={tooltipContent} position="bottom" withArrow multiline maw={350}>
        <Badge variant="light" color={badgeColor} size="sm" style={{ cursor: 'help' }}>
          {badgeText}
        </Badge>
      </Tooltip>
    );
  }
);

RateLimitBadge.displayName = 'RateLimitBadge';
